<template>

  <!-- <body>
    <div class="header">
      <div class="logo">
        <a href="#;">
          <img :src="logoSrc" />
        </a>
      </div>
    </div>
    <div class="wrapper c-bg" v-bind:style="{ 'background-image': 'url(' + bgSrc + ')'  }">
      <h1 class="tith1">信用卡開卡{{this.cardType}}</h1>
      <router-view />
    </div>

    <div id="footer">
      <a href="https://www.ctbcbank.com/twrbo/zh_tw/index/ctbc_aboutCTBC/ctbc_legal/ctbc_finances.html?targetTab=ctbc_finances_tab2" target="_blank">
        <div>
          <img class="foot-d" src="./assets/foot-d.png" />
        </div>
        <div>
          <img class="foot-m" src="./assets/foot-m.png" />
        </div>
      </a>
    </div>

    <div id="remind">
      <img :src="remindSrc" alt />
    </div>
  </body> -->
  <router-view />
</template>
<style src='./common/css/style.css'></style>
<style src='./common/css/pfixm.css'></style>
<style src='./common/css/plable.css'></style>
<style src='./common/css/mb.css'></style>
<style src='./common/css/fc.css'></style>
<style src="./common/css/info.css"></style>

<script>

export default {
  name: 'App',
  components: {
  },
  computed: {
  },
  data () {
    return {
    }
  },
  created () { },
  mounted () { },
  methods: {

  }
}
</script>
